/* eslint-disable react-hooks/exhaustive-deps, array-bracket-newline */
import React, { useState } from 'react';
import { LS_TRADES_KEY } from './Table';
import {
  compareNumericString,
  compareTradeDateString,
} from '../../../helpers/tableSort';

interface ITableWidths {
  date: number;
  priceUSD: number;
  price: number;
  numericIn: number;
  numericOut: number;
  txValue: number;
  statistics: number;
  wallet: number;
  tx: number;
  blocknumber: number;
  order: number;
}

// constants
const tableWidthsDefaultState: ITableWidths = {
  date: 176,
  priceUSD: 120,
  price: 110,
  numericIn: 150,
  numericOut: 150,
  txValue: 130,
  statistics: 90,
  wallet: 130,
  tx: 130,
  blocknumber: 140,
  order: 90,
};

interface IUseTableDataProps {
  trades: any;
  quote: string;
}

const useTableData = ({ trades, quote }: IUseTableDataProps) => {
  const tableWidthsLC = localStorage.getItem(LS_TRADES_KEY);

  const notUSDPrice = !quote.includes('USD');

  const [tableColumnsWidth] = useState(
    tableWidthsLC ? JSON.parse(tableWidthsLC) : tableWidthsDefaultState
  );

  // table memoized required fields
  const data = React.useMemo(() => trades, [trades]);
  const columns = React.useMemo(
    () => [
      {
        id: 'blocknumber',
        Header: 'Block number',
        accessor: 'blocknumber',
        width:
          tableColumnsWidth['blocknumber'] ||
          tableWidthsDefaultState['blocknumber'],
        sortType: compareNumericString(),
      },
      {
        id: 'date',
        Header: 'Date',
        accessor: 'timestamp',
        width: tableColumnsWidth['date'] || tableWidthsDefaultState['date'],
        sortType: compareTradeDateString,
      },
      ...(notUSDPrice
        ? [
          {
            id: 'priceUSD',
            Header: 'Price ($)',
            accessor: 'priceUSD',
            width:
              tableColumnsWidth['priceUSD'] ||
              tableWidthsDefaultState['priceUSD'],
            sortType: compareNumericString(),
          },
        ]
        : []),
      {
        id: 'price',
        Header: quote,
        accessor: 'price',
        width: tableColumnsWidth['price'] || tableWidthsDefaultState['price'],
        sortType: compareNumericString(),
      },
      {
        id: 'numericIn',
        Header: 'Amount',
        accessor: 'numericIn',
        width:
          tableColumnsWidth['numericIn'] ||
          tableWidthsDefaultState['numericIn'],
        sortType: compareNumericString(),
      },
      {
        id: 'numericOut',
        Header: 'Total',
        accessor: 'numericOut',
        width:
          tableColumnsWidth['numericOut'] ||
          tableWidthsDefaultState['numericOut'],
        sortType: compareNumericString(),
      },
      {
        id: 'txValue',
        Header: 'Tx Value ($)',
        accessor: 'txValue',
        width:
          tableColumnsWidth['txValue'] || tableWidthsDefaultState['txValue'],
        sortType: compareNumericString(),
      },
      {
        id: 'statistics',
        Header: 'Statistics',
        accessor: 'statistics',
        disableSortBy: true,
        width:
          tableColumnsWidth['statistics'] ||
          tableWidthsDefaultState['statistics'],
      },
      {
        id: 'wallet',
        Header: 'Address',
        accessor: 'wallet',
        disableSortBy: true,
        width: tableColumnsWidth['wallet'] || tableWidthsDefaultState['wallet'],
      },
      {
        id: 'tx',
        Header: 'Tx Hash',
        accessor: 'tx',
        disableSortBy: true,
        width: tableColumnsWidth['tx'] || tableWidthsDefaultState['tx'],
      },
      {
        id: 'order',
        Header: 'Log Order',
        accessor: 'order',
        width: tableColumnsWidth['order'] || tableWidthsDefaultState['order'],
      },
    ],
    [quote, notUSDPrice]
  );

  return { columns, data, tableColumnsWidth };
};

export { useTableData };
